import { render, staticRenderFns } from "./EditCompTableNoteDialog.vue?vue&type=template&id=0aed2b24&scoped=true"
import script from "./EditCompTableNoteDialog.vue?vue&type=script&lang=js"
export * from "./EditCompTableNoteDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aed2b24",
  null
  
)

export default component.exports